import React from "react";
import styles from "./Button.module.scss";
import { combineClasses } from "utils/utils";

const Button = ({ variant, children, className, leftIcon, rightIcon, ...rest }) => {
  const getClassname = () => {
    switch (variant) {
      case "outlined":
        return styles.outlined;

      case "filled":
        return styles.filled;

      default:
        return styles.normal;
    }
  };
  return (
    <button
      {...rest}
      className={combineClasses(className, styles.btn, getClassname())}
    >
      {
        leftIcon ? leftIcon : null
      }
      {children}
      {
        rightIcon ? leftIcon : null
      }
    </button>
  );
};

export default Button;
